/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import RoutablePage from '@modules/routing/RoutablePage'

import ProjectInitializationScreen from '../discovery-questions-pages/ProjectInitializationScreen'
import DeploymentInitializationScreen from '../discovery-questions-pages/DeploymentInitializationScreen'

import { RedirectOnboarding } from './redirectOnboarding'
import { RedirectServicesOnboarding } from './redirectServicesOnboarding'
import CreateOrgForCCMPage from './CreateOrgForCCMPage'

import OnboardingPage from '.'

import type { RouteObject } from 'react-router-dom'

const getServicesOnboardingRoutes = (isCCMFeatureActivated: boolean): RouteObject[] => {
  if (isCCMFeatureActivated) {
    return [
      {
        path: 'services/redirect',
        element: (
          <RoutablePage title="Let's get you set up!">
            <RedirectServicesOnboarding />
          </RoutablePage>
        ),
      },
      {
        path: 'ccm',
        element: (
          <RoutablePage title="Let's get you set up!">
            <CreateOrgForCCMPage />
          </RoutablePage>
        ),
      },
    ]
  }

  return []
}

export default function getOnboardingRoutes(isCCMFeatureActivated: boolean): RouteObject[] {
  return [
    {
      path: 'onboarding',
      children: [
        {
          path: 'redirect',
          element: (
            <RoutablePage title='Get Started with Elastic Cloud'>
              <RedirectOnboarding />
            </RoutablePage>
          ),
        },
        ...getServicesOnboardingRoutes(isCCMFeatureActivated),
        {
          path: ':onboardingTrialType/:questionId?',
          element: (
            <RoutablePage title='Get Started with Elastic Cloud'>
              <OnboardingPage />
            </RoutablePage>
          ),
        },
        {
          path: 'projects/create/:solution/:id/starting',
          element: (
            <RoutablePage title='Creating your new project'>
              <ProjectInitializationScreen />
            </RoutablePage>
          ),
        },
        {
          path: 'stateful/create/:id/starting',
          element: (
            <RoutablePage title='Creating your new deployment'>
              <DeploymentInitializationScreen />
            </RoutablePage>
          ),
        },
      ],
    },
  ]
}
